import NotificationContent from './component';

export default NotificationContent;
